import React from "react";
import { useNavigate } from "react-router-dom";
import { SsoSetupView } from "@nrgpix/auth-sso";
import SustinaSsoProvider from "./SustinaSsoProvider";
import { useCompanyContext } from "../../registered/common/company/CompanyContext";

/** Company → Single sign-on: the corporate SSO set-up workflow for the active company. */
export default function CompanySsoPage() {
    const navigate = useNavigate();
    const { activeCompanyId, activeCompanyName } = useCompanyContext();

    return (
        <main id="main" className="page-main registered-page" data-scroll-container>
            <div className="page-main-inner">
                <section className="page-section">
                    <div className="page-section__body">
                        <button className="btn btn-link px-0 mb-2" onClick={() => navigate("/registered/company-dashboard")}>
                            <i className="bi bi-arrow-left me-1" /> Back to {activeCompanyName || "company"}
                        </button>
                        <SustinaSsoProvider>
                            <SsoSetupView
                                corporateEntityId={activeCompanyId ? Number(activeCompanyId) : null}
                                title={`Single sign-on${activeCompanyName ? ` — ${activeCompanyName}` : ""}`}
                            />
                        </SustinaSsoProvider>
                    </div>
                </section>
            </div>
        </main>
    );
}
